import { Skeleton, Stack, Typography } from "@mui/material";

import { FilterTable } from "../../../../../Components/FilterTable/FilterTable";
import {
  type FilterTableItemDescriptor,
  generateHeadersAndFilters,
} from "../../../../../Components/FilterTable/filterTableUtils";
import { sortedValueToOption } from "../../../Clusters/Table/utils";
import { K8S_LENS_GLOSSARY } from "../../../messages";
import { type DashboardCluster } from "../../../types";
import { useClusterDashboardContext } from "./context";
import Fsk8sClusterTableRow from "./TableRow";

const Fsk8sClusterTable = () => {
  const { dashboardClusters, loading } = useClusterDashboardContext();

  const itemDescriptions: FilterTableItemDescriptor<DashboardCluster>[] = [
    {
      headerText: "Cluster name",
      value: "name",
      filterType: "string",
    },
    {
      headerText: "Type",
      value: "cloud",
      filterType: "string",
    },
    {
      headerText: "Agent status",
      value: "doitCluster.agentStatus",
      filterType: "string",
      filterOptions: {
        toOption: sortedValueToOption,
      },
    },
    {
      headerText: "Cost",
      value: "cost",
      filterType: "number",
      headerStyle: { align: "right" },
    },
    {
      headerText: "Potential savings",
      value: "potentialSavings",
      filterType: "number",
      headerStyle: { align: "right" },
      tooltip: K8S_LENS_GLOSSARY.POTENTIAL_SAVINGS,
    },
    {
      headerText: "Workload count",
      value: "workloads",
      filterType: "number",
      headerStyle: { align: "right" },
    },
    {
      headerText: "CPU requests (cores)",
      value: "cpuRequests",
      filterType: "number",
      headerStyle: { align: "right" },
    },
    {
      headerText: "Memory requests (Mi)",
      value: "memRequests",
      filterType: "number",
      headerStyle: { align: "right" },
    },
  ];

  if (loading) {
    return <Skeleton variant="rectangular" height={400} />;
  }

  const { headerColumns, filters } = generateHeadersAndFilters(itemDescriptions);

  const clusters = dashboardClusters.clusters ?? [];

  return (
    <Stack>
      <Typography variant="h4" sx={{ mb: -2 }}>
        Clusters ({clusters?.length ?? 0})
      </Typography>
      <FilterTable<DashboardCluster>
        rowComponent={Fsk8sClusterTableRow}
        persistenceKey="fsk8s-clusters-table"
        tableItems={clusters}
        headerColumns={headerColumns}
        filterColumns={filters}
        fillEmptySpace={false}
        defaultSortingColumnValue="cost"
        defaultSortDirection="desc"
      />
    </Stack>
  );
};

export default Fsk8sClusterTable;
